import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { ICustomEopSection } from '../../../../shared/models/eopSection';
import { CustomEopService } from '../../../../shared/services/customEop.service';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'edit-custom-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './edit-custom-page.component.html',
  styleUrl: './edit-custom-page.component.css'
})
export class EditCustomPageComponent implements OnInit {

  @Input() customPage: ICustomEopSection | null = null; // This is the custom page object to edit

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  newCustomPageTitle: string = '';
  loading: boolean = false;

  constructor(
    private customEopService: CustomEopService
  ) { }

  ngOnInit(): void {
    if (this.customPage && this.customPage.title) {
      this.newCustomPageTitle = this.customPage.title;
    }
  }

  updateCustomPage() {
    if (!this.newCustomPageTitle) return;
    const data = {
      title: this.newCustomPageTitle.trim(),
    }
    console.log('Updating custom page with data:', data);
    if (this.customPage) {
      this.loading = true;
      this.customEopService.updateCustomPage(String(this.customPage.id), data).subscribe({
        next: (response) => {
          this.loading = false;
          if (response.has_error) {
            console.error('Error updating custom page:', response.message);
          } else {
            this.onSave.emit({'type': 'success', 'message': 'This occurred after updating a custom page.'});
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error:', error.message);
          this.onSave.emit({type: 'unsuccess', 'message': error.message});
        }
      })
    }
  }

  handleClose() {
    this.onClose.emit();
  }

  get isTitleUnchanged(): boolean {
    return this.newCustomPageTitle.trim() === this.customPage?.title?.trim();
  }
  
}
